// components/layout/regionalNav.js
// The menu for accounts based outside Uganda (DRC). One "DwiSend" item opens
// the DwiSend page (/dwisend-drc — tabs Boutique · Mes commandes · Demandes,
// pages/DwiSendHub.jsx), like Uganda's one DwiSend item with tabs. A payment
// approver also gets Approbations, and sees DwiSend only when its client
// screens (requests or shop) are open to them. The Uganda menu is not here.
import { ShoppingBasket, ShieldCheck, Settings } from 'lucide-react';

export const DRC_HOME = '/dwisend-drc';

export function regionalNav({ fr = false, isApprover = false, shopOpen = false, requestsOpen = false } = {}) {
  const dwisend = [];
  if (!isApprover || requestsOpen || shopOpen) dwisend.push({ to: DRC_HOME, icon: ShoppingBasket, label: 'DwiSend' });
  if (isApprover) dwisend.push({ to: '/dwisend-approvals', icon: ShieldCheck, label: fr ? 'Approbations' : 'Approvals' });
  return [
    { group: 'DWISEND', items: dwisend },
    { group: 'ACCOUNT', items: [{ to: '/settings', icon: Settings, label: fr ? 'Paramètres' : 'Settings' }] },
  ];
}
